// Bundler alias target for `metabase/admin/components/AdminNav` — see the
// `IAS_UPSELL_ALIASES` block (misnamed for history; it now covers nav too) in
// `frontend/build/shared/rspack/resolve-aliases.js`.
//
// Wraps the upstream `AdminNavItem` so any sidebar link whose full path is in
// the IAS blocklist renders nothing. Combined with the route filter in
// `filterIasBlockedRoutes`, this drops the corresponding menu entry AND 404s
// the route, so the product doesn't advertise features the deployment hides.
//
// The overlay reaches the real components via the deeper specifier
// `metabase/admin/components/AdminNav/AdminNav`, which is NOT covered by the
// exact-match alias (`…/AdminNav$`) — so we avoid an import cycle.

import {
  type AdminNavItemProps,
  AdminNavWrapper,
  AdminNavItem as UpstreamAdminNavItem,
} from "metabase/admin/components/AdminNav/AdminNav";

import { isBlockedAdminRoute } from "./route-blocklist";

export type { AdminNavItemProps };
export { AdminNavWrapper };

export function AdminNavItem(props: AdminNavItemProps) {
  if (props.path && isBlockedAdminRoute(props.path)) {
    return null;
  }
  return <UpstreamAdminNavItem {...props} />;
}
